<div class="container">
  <p class="technicalError">{{ 'common_technicalErrorOccured' | translate }}</p>
  <div class="hairline"></div>
  <p class="sorryMessage">{{ 'common_sorryPageCantBeDisplayed' | translate }}</p>
  <button class="continueButton" (click)="continue()">
    {{ 'common_continueMyRequest' | translate }}    
  </button>
</div>